import { render, staticRenderFns } from "./monitoringPage.vue?vue&type=template&id=63063cd2&scoped=true&"
import script from "./monitoringPage.vue?vue&type=script&lang=js&"
export * from "./monitoringPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63063cd2",
  null
  
)

export default component.exports